import { Flex, Grid, Image, Stack } from '@chakra-ui/react';
import { Heading, Paragraph } from 'ui-components';

import { CheckboxCard } from './CheckboxCard';
import { usePlatformAnalyticsStore } from './usePlatformAnalyticsStore';

interface Props {
  isDemographicsDisabled: boolean;
}

export const PlatformDemographics = ({ isDemographicsDisabled }: Props) => {
  const { selectedDemographics, setSelectedDemographics } =
    usePlatformAnalyticsStore();

  return (
    <Stack spacing={2}>
      <Paragraph size="lg" fontWeight="medium">
        Audience Demographics
      </Paragraph>
      <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={4}>
        <CheckboxCard
          isChecked={
            !isDemographicsDisabled
              ? selectedDemographics.includes('gender')
              : false
          }
          onChange={() => {
            setSelectedDemographics('gender');
          }}
          isDisabled={isDemographicsDisabled}
        >
          <Flex alignItems="center">
            <Image
              src={
                !isDemographicsDisabled
                  ? '/images/media-kits/donut.png'
                  : '/images/media-kits/disabled_donut.png'
              }
              width="auto"
              height="4.5rem"
            />
            <Heading size="sm">Gender Distribution</Heading>
          </Flex>
        </CheckboxCard>
        <CheckboxCard
          isChecked={
            !isDemographicsDisabled
              ? selectedDemographics.includes('age')
              : false
          }
          onChange={() => {
            setSelectedDemographics('age');
          }}
          isDisabled={isDemographicsDisabled}
        >
          <Flex alignItems="center">
            <Image
              src={
                !isDemographicsDisabled
                  ? '/images/media-kits/bar.png'
                  : '/images/media-kits/disabled_bar.png'
              }
              width="auto"
              height="4.5rem"
            />
            <Heading size="sm">Age Distribution</Heading>
          </Flex>
        </CheckboxCard>
        <CheckboxCard
          isChecked={
            !isDemographicsDisabled
              ? selectedDemographics.includes('country')
              : false
          }
          onChange={() => {
            setSelectedDemographics('country');
          }}
          isDisabled={isDemographicsDisabled}
        >
          <Flex alignItems="center">
            <Image
              src={
                !isDemographicsDisabled
                  ? '/images/media-kits/country.png'
                  : '/images/media-kits/disabled_country.png'
              }
              width="auto"
              height="4.5rem"
            />
            <Heading size="sm">Country Distribution</Heading>
          </Flex>
        </CheckboxCard>
      </Grid>
    </Stack>
  );
};
